module.exports = __webpack_public_path__ + "img/bluecheck.3f0ce322.svg";